import { useAuth } from '@shared/components/AuthProvider';

/**
 * Reads the current user's email verification status.
 *
 * Used to gate features (e.g. website publish) behind email verification —
 * see useEmailVerificationDialog for the interactive verify flow.
 */
export const useEmailVerificationGate = () => {
  const { currentUser } = useAuth();

  const isEmailVerified = currentUser.profile?.emailIsVerified ?? false;

  return {
    isEmailVerified,
  };
};
